<template>
  <div :class="severityColorClass" class="tw:rounded-lg tw:lg:min-h-[62px] tw:text-sm tw:relative tw:py-4 tw:mb-[2px]">
    <!-- Dismiss button - Absolute positioned -->
    <button
      v-if="dismissible"
      class="tw:absolute tw:top-3 tw:right-3 tw:outline-none tw:cursor-pointer tw:z-10 tw:p-1 tw:transition-colors"
      @click="handleDismiss"
      @keydown.enter="handleDismiss"
      aria-label="Dismiss notification"
      type="button"
    >
      <Close class="tw:size-2.5" />
      <span class="tw:sr-only">Dismiss</span>
    </button>

    <!-- Content wrapper - Full width -->
    <div class="tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:xl:px-4 tw:px-4">
      <div class="tw:flex tw:flex-col tw:flex-1 tw:gap-3 tw:md:justify-between">
        <!-- Text content -->
        <div class="tw:flex-1" :class="dismissible ? 'tw:pr-4' : ''">
          <div v-if="header" class="tw:flex tw:items-center tw:text-sm">
            <strong>{{ header }}</strong>
          </div>
          <p v-html="description" class="tw:text-sm" />
        </div>

        <!-- CTA slot -->
        <slot name="ctaContent" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'

import Close from '@/components/icons/Close.svg?component'

const dismissNotification = inject('dismissNotification')
const props = defineProps({
  description: {
    type: String,
    required: true,
    default: '',
  },
  header: {
    type: String,
    required: false,
    default: '',
  },
  severity: {
    type: String,
    required: false,
    default: 'INFO',
    validator(value) {
      return ['CRITICAL', 'WARNING', 'INFO'].includes(value)
    },
  },
  dismissible: {
    type: Boolean,
    required: false,
    default: false,
  },
  id: {
    type: String,
    required: true,
    default: '',
  },
  ttl: {
    type: Number,
    required: false,
  },
})

const severityColorClass = computed(() => {
  if (props.severity === 'CRITICAL') return 'tw:bg-red-200'
  if (props.severity === 'WARNING') return 'tw:bg-orange-200'
  return 'tw:bg-blue-200'
})

const handleDismiss = () => {
  dismissNotification(props.id, props.ttl)
}
</script>
